import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { IComparisonInfo } from "../../declarations/types";
import { IReadVerbPayload } from "../../declarations/IReadVerbPayload";

const getCustomerComparison = async (
    payload: IReadVerbPayload,
): Promise<IComparisonInfo[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.post<IComparisonInfo[]>(
        `/Customer/CustomerComparisonInfoD365`,
        payload,
    );
    return response.data;
};

export const useGetCustomerComparison = (payload: IReadVerbPayload) => {
    const dataAreaId = payload.keys.dataAreaId as string;
    const CustomerAccount = payload.keys.customerAccount as string;
    const SalesAccID = payload.keys.salesAccID as number;

    return useQuery<IComparisonInfo[]>({
        queryKey: [
            "GetCustomerComparisonInfoD365",
            {
                SalesAccID: SalesAccID ?? null,
                dataAreaId: dataAreaId ?? null,
                customerAccount: CustomerAccount ?? null,
            },
        ],
        queryFn: () => {
            if (
                !SalesAccID ||
                SalesAccID <= 0 ||
                !dataAreaId ||
                !CustomerAccount
            ) {
                throw new Error(
                    "Invalid params for GetCustomerComparisonInfoD365",
                );
            }
            return getCustomerComparison(payload);
        },
        enabled:
            Boolean(
                !SalesAccID ||
                    SalesAccID <= 0 ||
                    !dataAreaId ||
                    !CustomerAccount,
            ) === false,
        refetchOnWindowFocus: false,
        retry: false,
    });
};
